{
  "$id": "module://performance-rule",
  "$schema": "wealthlane://schemas/domain",
  "title": "Performance Rule",
  "description": "Performance rule field catalog — maps to Add/Update PerformanceRules DTO",
  "type": "object",
  "$defs": {
    "percentageNumber": {
      "type": "number",
      "minimum": 0,
      "inputPrecision": 4,
      "displayPrecision": 4,
      "displayFormat": "number",
      "widget": "number"
    }
  },
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "ruleName": {
      "type": "string",
      "title": "Rule Name",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true,
      "maxLength": 100
    },
    "ruleTypeId": {
      "$ref": "module://participant#/$defs/addressCountryId",
      "title": "Rule Type"
    },
    "isAvailable": {
      "type": "boolean",
      "title": "Available",
      "widget": "checkbox",
      "default": false
    },
    "evaluationPeriodStartDate": {
      "type": "string",
      "title": "Start Date",
      "widget": "date",
      "format": "date"
    },
    "evaluationPeriodEndDate": {
      "type": "string",
      "title": "End Date",
      "widget": "date",
      "format": "date"
    },
    "minimumPercentage": {
      "$ref": "#/$defs/percentageNumber",
      "title": "Minimum %"
    },
    "maximumPercentage": {
      "$ref": "#/$defs/percentageNumber",
      "title": "Maximum %"
    },
    "ruleDescription": {
      "type": "string",
      "title": "Rule",
      "widget": "textarea",
      "noBlank": true,
      "adapterProps": { "rows": 3 }
    },
    "ruleSummary": {
      "type": "string",
      "title": "Rule Display",
      "widget": "textarea",
      "noBlank": true,
      "adapterProps": { "rows": 3 }
    },
    "showRuleDisplayToParticipant": {
      "type": "boolean",
      "title": "Show to participant",
      "widget": "checkbox",
      "default": false
    },
    "showPerformanceTrackingToParticipant": {
      "type": "boolean",
      "title": "Show tracking history to participant",
      "widget": "checkbox",
      "default": false
    },
    "performanceEvaluationId": {
      "type": "string",
      "title": "Performance Evaluation ID",
      "widget": "hidden"
    },
    "evaluationDate": {
      "type": "string",
      "title": "Evaluation Target Date",
      "widget": "date",
      "format": "date"
    },
    "earnedMultipier": {
      "$ref": "#/$defs/percentageNumber",
      "title": "Earned Multiplier %",
      "adapterProps": { "placeholder": "Auto-calculated or manual override" }
    },
    "trackingDate": {
      "type": "string",
      "title": "Effective Date",
      "widget": "date",
      "format": "date"
    },
    "multiplierPercentage": {
      "$ref": "#/$defs/percentageNumber",
      "title": "Multiplier (%)",
      "adapterProps": { "placeholder": "0.0000" }
    },
    "comment": {
      "type": "string",
      "title": "Comment / Justification",
      "widget": "text",
      "adapterProps": { "placeholder": "Add details..." }
    },
    "minValue": {
      "type": "number",
      "title": "Min Value",
      "widget": "hidden"
    },
    "maxValue": {
      "type": "number",
      "title": "Max Value",
      "widget": "hidden"
    }
  }
}
